import { TextAlignment } from 'src/graphql/generated/graphql'

// We have defaults here in case the settings are accdentialy deleted from soc admin
export const defaultEditorSettings = {
  image: {
    minZoom: 50,
    maxZoom: 200,
    keepAspectRatio: false,
  },
  text: {
    fontColor: { r: 0, g: 0, b: 0 },
    fontFamily: 'ArchitectsDaughter-Regular',
    fontSize: 16,
    lineHeight: 1.3,
    justification: 'CENTER' as TextAlignment,
    signatureId: '',
  },
}
export type DefaultEditorSettingsType = typeof defaultEditorSettings

export const applicationSettings = {
  card_editor: defaultEditorSettings,
  // Add more apps here
} as const

export type ApplicationSettings = typeof applicationSettings
export type AppLabel = keyof ApplicationSettings
